import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/home';

const footerLinks = {
  platform: {
    title: '平台导航',
    links: [
      { label: '首页', path: '/' },
      { label: '内容分类', path: '/category/variety' },
      { label: '关于我们', path: '/about' },
      { label: '使用教程', path: '/#tutorial' },
      { label: '常见问题', path: '/#faq' },
    ],
  },
  category: {
    title: '热门分类',
    links: [
      { label: '综艺娱乐', path: '/category/variety' },
      { label: '影视剧场', path: '/category/movie' },
      { label: '知识科普', path: '/category/knowledge' },
      { label: '音乐舞蹈', path: '/category/music' },
      { label: '游戏电竞', path: '/category/game' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '帮助中心', path: '/about' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
      { label: '版权声明', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-xs">
              {siteConfig.description}
            </p>
            <div className="flex items-center gap-4 mt-5">
              {[
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-bilibili-line', label: 'B站' },
                { icon: 'ri-tiktok-line', label: '抖音' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-9 h-9 rounded-full bg-secondary-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-background-50 text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            {siteConfig.copyright}
          </p>
          <p className="text-xs text-foreground-400">
            客服热线：{siteConfig.customerService} | 邮箱：{siteConfig.contactEmail}
          </p>
        </div>
      </div>
    </footer>
  );
}